import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 32px;
  margin-top: 104px;
`;

export const PageTitle = styled.h1`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 24px;
`;

export const BodyContainer = styled.div`
  width: 100%;
  padding: 36px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px;
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
`;

// Novos estilos para a visualização como página
export const PageContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  width: 100%;
  margin-top: 66px;
  padding: 24px;
  background-color: #f5f8ff;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 16px 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  h1 {
    color: #101828;
    font-family: Inter;
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background-color: #eaefff;
  color: #2d5bff;
  padding: 8px 16px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #d8e1ff;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-left: 20px;
`;

export const Button = styled(IconButton)``;
